const RichText = theme => {
  return {
    fontWeight: 100,
    fontSize: theme.typography.body1.fontSize,
    color: theme.typography.body1.color,
    fontFamily: theme.typography.body1.fontFamily,
    marginBottom: theme.spacing.unit * 3,
    marginTop: theme.spacing.unit * 3,
    '& h2': theme.typography.title,
    '& h3': theme.typography.subheading
  }
}

export default RichText



// WEBPACK FOOTER //
// ./src/styles/mixins/richText.js